import React, { useState, useEffect } from "react";
import { Input, Select, Label } from "../../Common/Forms";
import Spinner from "../../Common/Spinner";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  fetchOrganization,
  leaveOrganization,
  addStaffNumber,
} from "../../../actions/SessionAction";
import { showOrganizationSidebar } from "../../../actions/GlobalAction";
import AddStaffModal from "./AddStaffModal";
import OrganizationFormModal from "../../Conversation/Setting/OrganizationFormModal";
import Loading from "../../Pages/Signup/Loading"
import { ToastContainer } from "react-toastify";
import "./OrganizationContainer.css";
import Notify from "../../Common/Notify";

const OrganizationContainer = ({ notificationType = 1 }) => {
  const dispatch = useDispatch();

  const {
      organizationSettingShown,
    } = useSelector(
      (state) => ({
        organizationSettingShown: state.global.organizationSettingShown,
      }),
      shallowEqual,
    );

  const [org, setOrganization] = useState({});
  const [members, setMembers] = useState([]);
  const [isLoading, setIsloading] = useState(true);
  const [openAddMemberModal, setOpenAddMember] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [placeholder, setPlaceholder] = useState(false);
  const [openCreateOrgModal, setOpenCreateOrgModal] = useState(false);
  const imageURL = require("../../../assets/images/default.png");
  const defaultImageURL = require("../../../assets/images/default.png");

  useEffect(() => {
    handleFetchOrganization();
  }, []);

  const handleFetchOrganization = () => {
    dispatch(fetchOrganization()).then((org) => {
      if (org) {
        setOrganization(org);
        const owner = org.owner;
        const tempAdminstrators = org.administrators || [];
        const tempMembers = org.members || [];
        const tempGuests = org.guests || [];
        const combined = [
          ...tempAdminstrators,
          ...tempMembers,
          ...tempGuests,
        ].filter((i) => i.objectId !== owner.objectId);
        setMembers(combined);
        setPlaceholder(false);
        dispatch(showOrganizationSidebar(true)); // Demo trigger
      } else {
        setPlaceholder(true);
      }
      setIsloading(false);
    });
  };

  const handleLeaveOrg = () => {
    setIsloading(true);
    dispatch(leaveOrganization())
      .then((res) => {
        if (res.message) {
          Notify.info(
            "Success. You are no longer a member of any organization.",
          );
          setOrganization({});
          setPlaceholder(true);
          setOpenConfirm(false);
          setIsloading(false);
        } else {
          Notify.error("Error: something went wrong");
          setOpenConfirm(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsloading(false);
      });
  };

  const handleInviteStaff = (number) => {
    if (number !== "") {
      dispatch(addStaffNumber(number))
        .then((res) => {
          setOpenAddMember(false);
          if (res.organization) {
            Notify.info("Added staff to organization.");
            setIsloading(true);
            handleFetchOrganization();
          }
          if (res.error_message) {
            Notify.error(res.error_message);
          }
        })
        .catch((message) => {
          console.log("error", message);
        });
    } else {
      Notify.error("Invalid phone number");
    }
  };

  const handleCreateNFetch = () => {
    Notify.info("Successfully created organization.");

    setOpenCreateOrgModal(false);
    setIsloading(true);
    handleFetchOrganization();
  }

  const handleUpdateNFetch = (organizationName) => {
    Notify.info("Successfully updated organization.");

    setOpenCreateOrgModal(false);
    setOrganization(prev => ({
      ...prev,
      name: organizationName,
    }));
  }

  // IN APP DEMO TUTORIAL
  useEffect(() => {
    switch (organizationSettingShown) {
      case "update": break;
      case "add-modal":
        setOpenAddMember(true);
        break;
      case "add-error":
        setOpenAddMember(false);
        Notify.error(
          "This user is already linked to another organization and must leave it before being added to yours.",
          { autoClose: false }
        );
        break;
      case "add-success":
        Notify.dismiss();
        Notify.info("Added staff to organization.", { autoClose: false });
        break;
      case "demo-leave":
        Notify.dismiss();
        setOpenConfirm(true);
        break;
      case "demo-finished":
        Notify.dismiss();
        setOpenConfirm(false);
        break;
    }
  }, [organizationSettingShown]);

  return (
    <div className="corporate-members">
      {placeholder && !isLoading && (
        <React.Fragment>
          <div className="org-em-container full-row" style={{ marginTop: "40px" }}>
            <em>No Organization found</em>
          </div>
          <div className="org-create-action">
            <button
              type="button"
              className="btn btn-success btn-block"
              onClick={() => setOpenCreateOrgModal(true)}
            >
              <i className="fas fa-city fa-fw" style={{ margin: "0 10px" }}></i>
              Create Organization
            </button>
          </div>
        </React.Fragment>
      )}
      {!placeholder && (
        <React.Fragment>
          <div className="organization-form-row">
            <div
              id="hc-profile-setting-org-owner"
              className="main-sub-header"
              style={{ marginTop: "10px", textTransform: "capitalize" }}
            >
              {org && org.name}
            </div>
            <span className="">
              <div className="dropdown">
                <button
                  id="hc-profile-setting-org-update"
                  className="btn dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ float: "right" }}
                >
                  <i className="fas fa-ellipsis-v"></i>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="hc-profile-setting-org-update"
                >
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => setOpenCreateOrgModal(true)}
                  >
                    Update details
                  </button>
                  {/* <button className="dropdown-item" type="button">
                    Action 2
                  </button> */}
                </div>
              </div>
            </span>
          </div>
          
          <small className="main-sub-header-3">Owner</small>
          <div className="organization-form-row">
            <div className="org-owner-img">
              <img
                src={
                  isLoading
                    ? imageURL
                    : org.owner.picture
                    ? org.owner.picture.url
                    : imageURL
                }
                alt="Profile Picture"
              />
              <div>
                <p>{org && org.owner && org.owner.displayName}</p>
                <p>{org && org.owner && org.owner.orgRole}</p>
              </div>
            </div>
            
          </div>
          <div className="main-sub-header">
            <small className="main-sub-header-3">Members</small>
            <div>
              <span className="org-add-action">
                <button
                  id="hc-profile-setting-org-add"
                  type="button"
                  className="btn btn-primary btn-sm"
                  style={{ marginLeft: "auto" }}
                  onClick={() => setOpenAddMember(true)}
                >
                  <i className="fas fa-plus"></i> Add member
                </button>
              </span>
            </div>
          </div>
          <div className="org-members-table">
            <div className="members-header organization-form-row">
              <span style={{ marginLeft: "40px" }}>Name</span>
              {/* <span>Corp. position</span>
              <span>Authorization</span> */}
              <span>
                {/* <span style={{ float: "right" }}>{filteredItems.length + 1}</span> */}
              </span>
            </div>
            <div className="org-table-overflow">
              {isLoading && !placeholder && (
                <CustomLoader isLoading={isLoading} />
              )}
              {!isLoading &&
                members.length > 0 &&
                members.map((item, key) => (
                  <div className="corporate-members-table-row" id={key}>
                    <div className="members-img" style={{ display: "flex" }}>
                      <img
                        src={item.picture ? item.picture.url : defaultImageURL}
                        alt="Group Profile Picture"
                      />
                      <div className="org-member-displayName">
                        <p>{item.displayName}</p>
                        <p>{item.profession}</p>
                      </div>
                    </div>
                    {/*  */}
                    {/* <span>
                      <FilterBadge access={item.source} />
                    </span>
                    <span></span> */}
                    <span>
                      {/* <div className="dropdown dropleft">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="memberDropdownMenu"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          style={{ float: "right" }}
                        >
                          <i className="fas fa-ellipsis-v"></i>
                        </button>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="memberDropdownMenu"
                        >
                          <button
                            className="dropdown-item"
                            type="button"
                            // onClick={this.removeMember}
                          >
                            <i className="fas fa-trash mr-1"></i>
                            Action 1
                          </button>
                          {item.access != "guest" && (
                            <button className="dropdown-item" type="button">
                              <i className="fas fa-user-tie mr-1"></i>
                              Action 2
                            </button>
                          )}
                        </div>
                      </div> */}
                    </span>
                  </div>
                ))}
                {!isLoading && members.length === 0 &&
                  <div className="org-em-container full-row">
                    <em>No Member found</em>
                  </div>
                }
            </div>
          </div>
          <div className="org-leave-action">
            <button
              type="button"
              className="btn btn-danger btn-block"
              onClick={() => setOpenConfirm(true)}
            >
              Leave Organization
            </button>
          </div>
        </React.Fragment>
      )}
      {openCreateOrgModal && (
        <OrganizationFormModal
          isOpen={openCreateOrgModal}
          onClose={() => setOpenCreateOrgModal(false)}
          handleCreateNFetch={handleCreateNFetch}
          handleUpdateNFetch={handleUpdateNFetch}
          isLoading={isLoading}
          org={org}
        />
      )}
      {openAddMemberModal && (
        <AddStaffModal
          handleInviteStaff={handleInviteStaff}
          isOpen={openAddMemberModal}
          modalClose={() => setOpenAddMember(false)}
          isLoading={isLoading}
        />
      )}
      {openConfirm && (
        <Confirmation
          handleLeaveOrg={() => handleLeaveOrg()}
          onClose={setOpenConfirm}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

const Confirmation = ({ handleLeaveOrg, onClose = () => {}, isLoading }) => {
  return (
    <div
      id="hc-profile-setting-org-leave"
      className="assignment-notify-container"
    >
      <div className="attention-notify-box org-leave-custom-container" style={{ width: "auto" }}>
        <div className="save-changes-flex">
          <h6 style={{ fontWeight: "bold" }}>Leave organization ?</h6>
          <h6>Are you sure you want to leave current organization.</h6>
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <button
              type="button btn-sm"
              style={{ marginRight: "10px" }}
              className="btn btn-danger"
              disabled={isLoading}
              onClick={() => handleLeaveOrg()}
            >
              Leave
            </button>
            <button
              type="button btn-sm"
              className="btn btn-hubchart btn-hubchart-close"
              disabled={isLoading}
              onClick={() => onClose(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CustomLoader = ({ isLoading }) => {
  return (
    <div
      className="loader"
      style={{
        display: isLoading ? "inline-grid" : "none",
        position: "absolute",
        overflow: "hidden",
        backgroundColor: "#ffffff",
      }}
    >
      <div align="center">
        <div className="loader-container">
          <div>
            <div className="loader-message">
              <span>Please wait...</span>
              <Spinner size={5} color={"#fbba09"} loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationContainer;
